/**
 * @file   : DestinationLayoutFacility.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 9/26/2018, 12:42:38 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import Cont from '../../../external/components/layout/Cont'
import Divider from '../../../external/components/layout/Divider'
import { isEmpty, isUndefined } from '../../../external/utilities/GeneralUtils'
import DestinationSummaryCard from './DestinationSummaryCard'

const DestinationLayoutFacility = ({ theme, intl, destinationProducts }) => {
  const getDestinationProductsUI = function () {
    const ui = destinationProducts.data.map((destinationProduct, i) => (
      <Cont key={i}>
        <DestinationSummaryCard
          intl={intl}
          theme={theme}
          destinationProduct={destinationProduct}
        />
        <Divider />
      </Cont>
    ))

    return ui
  }

  if (isUndefined(destinationProducts) || isEmpty(destinationProducts)) {
    return null
  }

  return <Cont>{getDestinationProductsUI()}</Cont>
}

DestinationLayoutFacility.propTypes = {
  theme: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
  destinationProducts: PropTypes.object,
}

export default DestinationLayoutFacility
